import { supabase, handleError } from './apiClient'

export async function loginAdmin(credentials) {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: credentials.username,  // Supabase expects email
      password: credentials.password
    });

    if (error) {
      return {
        success: false,
        message: error.message || 'Invalid credentials. Please try again.'
      };
    }

    if (!data.session) {
      return {
        success: false,
        message: 'Session not created. Please try again.'
      };
    }

    return {
      success: true,
      token: data.session.access_token,
      username: data.user.email,
      user: data.user
    };
  } catch (error) {
    console.error('Login error:', error);
    return {
      success: false,
      message: error.message || 'Login failed. Please try again.'
    };
  }
}

export async function validateAdminToken() {
  try {
    const { data: { user }, error } = await supabase.auth.getUser()
    return !error && user !== null
  } catch (error) {
    return false
  }
}

export async function fetchAdminStats() {
  try {
    const { count: totalProperties } = await supabase
      .from('properties')
      .select('*', { count: 'exact', head: true })
    
    const { count: availableProperties } = await supabase
      .from('properties')
      .select('*', { count: 'exact', head: true })
      .eq('status', 'AVAILABLE')
    
    const { count: totalInquiries } = await supabase
      .from('inquiries')
      .select('*', { count: 'exact', head: true })
    
    const { count: pendingInquiries } = await supabase
      .from('inquiries')
      .select('*', { count: 'exact', head: true })
      .eq('status', 'OPEN')

    return {
      totalProperties: totalProperties || 0,
      availableProperties: availableProperties || 0,
      totalInquiries: totalInquiries || 0,
      pendingInquiries: pendingInquiries || 0
    }
  } catch (error) {
    handleError(error, 'fetchAdminStats')
  }
}

export async function changeAdminPassword(currentPassword, newPassword) {
  try {
    const { data: { user }, error: getUserError } = await supabase.auth.getUser();
    
    if (getUserError || !user) {
      return {
        success: false,
        message: 'Authentication failed. Please login again.'
      };
    }

    const userEmail = user.email;
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: userEmail,
      password: currentPassword
    });

    if (signInError) {
      return {
        success: false,
        message: 'Current password is incorrect.'
      };
    }

    const { error: updateError } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (updateError) {
      return {
        success: false,
        message: updateError.message || 'Failed to update password.'
      };
    }

    return {
      success: true,
      message: 'Password changed successfully'
    };

  } catch (error) {
    console.error('Error in changeAdminPassword:', error);
    return {
      success: false,
      message: error.message || 'Error changing password. Please try again.'
    };
  }
}
